import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, DialogTrigger, Image, makeStyles, Text, Tooltip } from "@fluentui/react-components";
import IAward from "../../../models/award/IAward";
import { ChevronLeft20Filled, ChevronRight20Filled } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "row",
        columnGap: "1rem",
        marginTop: ".5rem",
    },
    imageContainer: {
        display: "block",
        width: "60%",
        textAlign: "center"
    },
    detailsContainer: {
        display: "block",
        width: "40%",
        textAlign: "left"
    },
    modalImage: {
        display: "block",
        maxWidth: "100%",
        height: "auto",
        maxHeight: "400px",
        objectFit: "contain",
        "margin": "0 auto"
    },
    details: {
        display: "block",
        width: "100%",

        "& p:first-of-type": {
            marginTop: "0"
        }
    },
    actions: {
        width: "100%",

        "& button:last-of-type": {
            marginLeft: "auto"
        }
    },
    navigationButton: {
        minWidth: "40px"
    }
});

interface IAwardModalProps {
    award?: IAward;
    isOpen: boolean;
    showNextAward: () => void;
    showPrevAward: () => void;
    onDismiss: () => void;
}

export default function AwardModal(props: IAwardModalProps) {
    const { t } = useTranslation("general");
    const { award } = props;
    const styles = useStyles();

    if (!award) {
        return null;
    }

    return (
        <Dialog open={!!props.isOpen} onOpenChange={props.onDismiss}>
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>
                        {award.name}
                    </DialogTitle>
                    <DialogContent>
                        <div className={styles.container}>
                            <div className={styles.imageContainer}>
                                <Image
                                    src={award.image.url}
                                    alt={award.image.altText}
                                    className={styles.modalImage}
                                    />
                            </div>
                            <Text className={styles.details}>
                                <span dangerouslySetInnerHTML={{ __html: award.description }} />
                            </Text>
                        </div>
                    </DialogContent>
                    <DialogActions fluid className={styles.actions}>
                        <Tooltip content={t("previous")} relationship="label">
                            <Button appearance="primary" className={styles.navigationButton} onClick={props.showPrevAward}>
                                <ChevronLeft20Filled />
                            </Button>
                        </Tooltip>
                        <Tooltip content={t("next")} relationship="label">
                            <Button appearance="primary" className={styles.navigationButton} onClick={props.showNextAward}>
                                <ChevronRight20Filled />
                            </Button>
                        </Tooltip>
                        <DialogTrigger disableButtonEnhancement>
                            <Button appearance="secondary" onClick={props.showNextAward}>
                                {t("close")}
                            </Button>
                        </DialogTrigger>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
}